<template>
  <div>
    <div class="collection-hero__wrapper">
      <div class="collection-hero collection-hero__with-border t-d">
        <div class="collection-hero__text collection-hero__header">
          <h1>{{ header.title }} </h1>
        </div>
        <div class="collection-hero__text collection-hero__content">
          <div>
          </div>
          <p class="body-sm-mobile body-md-tablet-up" v-html="header.content">
          </p>
        </div>
      </div>
    </div>
    <div class="brands container">
      <div class="brands__list" v-for="collection in brands">
          <div class="brands__column">
            <a :href="collection.url"><img :src="collection.brandpageImage ? collection.brandpageImage : collection.image"
                alt="" class="brand__image"></a>
                
          </div>
          <div class="brands__column2">
            <a :href="collection.url" class="brands__heading-link"><h2>{{ collection.title }}</h2></a>
            <div class="brands__sub-heading" v-html="collection.subtitle"></div>
            <p v-html="collection.desc"></p>
          </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  component: 'Brands',
  props: {
    brands: {
      type: Array,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    data() {
      return {
        isB2B: window.bvaccel.b2b
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1200px;
}

.brands {
  &__list {
    display: flex;
    padding: 20px;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    align-items: center;
    align-items: flex-start;
    margin-bottom: 1rem;

    @include mobile-only {
      flex-direction: column;
      align-items: center;
      padding-left: 0;
      padding-right: 0;

    }
  }

  &__column {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 1;
    // padding: 5px;
  }

  &__column2 {
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    flex: 2;
    padding-left: 20px;

    @include mobile-only {
      padding-left: 5px;
      padding-right: 5px;

    }
  }

  &__heading-link{
    text-decoration: none;
    color:$color-black-900;

    h2 {
      font-family: "Ginkgo-Light";
      font-size: 2.66667rem;
      line-height: 3.2rem;
    }

  }
  &__sub-heading {
    line-height: 1em;
    margin-bottom: 15px;
  }

}

.collection-hero__wrapper {
  padding: 0 32px;

  @include mobile-only {
    padding: 0 15px;
  }
}

.collection-hero {
  width: 100%;
  //min-height: 400px;
  display: flex;
  align-items: center;
  padding: 45px 0 45px;

  &__with-border {
    border-top: 1px solid #979391;
    border-bottom: 1px solid #979391;

    @include mobile-only {
      border-color: transparent;
    }
  }

  @include mobile-only {
    padding: 30px 0 30px;
    min-height: 0;
    //max-width: 344px;
    margin: 0 auto;
    display: block;
  }

  &__text {
    padding: 0 32px;
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;

    @include mobile-only {
      padding: 0px 15px;
      width: 100%;
      text-align: center;
      min-height: 0;
    }

    h1 {
      margin: auto;
      font-size: 52px;
      letter-spacing: 0;
      line-height: 1;
      font-family: "Ginkgo-Light";
      font-weight: 400;
      text-transform: none;
      padding-bottom: 10px;


      @include mobile-only {
        font-size: 28px;
      }
    }

    p {
      font-size: 15px;
      letter-spacing: -0.1px;
      line-height: 23px;

      //margin: 16px 0 0;
      @include mobile-only {
        //margin: 8px 0 0;
        margin: 0 auto;
      }
    }
  }

  &__header {
    h1 {
      text-align: center;
    }
    @include mobile-only {
      padding-bottom: 12px;

      img {
        padding-bottom: 24px;
      }
    }
  }
}
</style>
